import { Modal, Radio, Space, Typography } from "antd";
import { StarFilled } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDateRangeWithDateString } from "../../Helpers/DateHelpers";
import { getCurrentLanguage } from "../../Helpers/RouteHelper";
import { TextService } from "../../Services/TextService";
import { CloseEventModal } from "./CloseEventModal";

const { Text } = Typography;

/**
 * When a poll has got its time, the next step usually is a sign-up for that time. Nothing is sent
 * to the guests here, the form for a new event is just filled in.
 */
export const useOfferSignUpForChosenTime = (event: any) => {
    const navigation = useNavigate();
    const GetText = TextService.GetText;

    return (time: any) => {
        Modal.confirm({
            title: GetText("ReplyTable_CreateSignUpTitle"),
            content: GetText("ReplyTable_CreateSignUpDescription"),
            okText: GetText("ReplyTable_CreateSignUpOk"),
            cancelText: GetText("ReplyTable_CreateSignUpCancel"),
            onOk: () => {
                navigation("/" + getCurrentLanguage() + "/create", {
                    state: {
                        prefill: {
                            name: event.eventName,
                            description: event.eventDescription,
                            location: event.eventLocation,
                            start: new Date(time.start).toISOString(),
                            end: new Date(time.end).toISOString(),
                            isFullDay: time.isFullDay === true
                        }
                    }
                });
            }
        });
    };
};

/**
 * Closes a poll from its status: first the final time is chosen among the times with their votes (the one
 * with the most votes is chosen from start), then the same closing as when a time is clicked in the replies.
 */
export const ClosePollModal = (props: { event: any, open: boolean, onCancel: () => void, onClosed: () => void }) => {
    const GetText = TextService.GetText;
    const [chosenTimeId, setChosenTimeId] = useState(undefined as any);
    const [showCloseModal, setShowCloseModal] = useState(false);
    const offerSignUpForChosenTime = useOfferSignUpForChosenTime(props.event);
    const times: any[] = props.event.times ?? [];
    const chosenTime = times.find(time => time.id === chosenTimeId);

    useEffect(() => {
        if (props.open) {
            const mostVotes = times.find(time => time.hasMostYesCount) ?? times[0];
            setChosenTimeId(mostVotes?.id);
        }
    }, [props.open]);

    return <>
        <Modal
            title={GetText("ReplyTable_ClosePollTitle")}
            open={props.open && !showCloseModal}
            okText={GetText("ClosePoll_Next")}
            cancelText={GetText("Common_Cancel")}
            okButtonProps={{ disabled: !chosenTime }}
            onOk={() => setShowCloseModal(true)}
            onCancel={props.onCancel}
        >
            <p><i>{GetText("ClosePoll_ChooseTime")}</i></p>
            <Radio.Group value={chosenTimeId} onChange={(e) => setChosenTimeId(e.target.value)}>
                <Space direction="vertical">
                    {times.map(time =>
                        <Radio key={time.id} value={time.id}>
                            {formatDateRangeWithDateString(time.start, time.end, time.isFullDay, getCurrentLanguage() === "se")}
                            <Text type="secondary"> · {time.yesCount ?? 0} {GetText("ClosePoll_Votes")}</Text>
                            {time.hasMostYesCount ? <StarFilled style={{ color: "#faad14", marginLeft: 6 }} /> : null}
                        </Radio>)}
                </Space>
            </Radio.Group>
        </Modal>
        <CloseEventModal event={props.event} open={props.open && showCloseModal} chosenTime={chosenTime}
            onCancel={() => setShowCloseModal(false)}
            onClosed={(time) => { setShowCloseModal(false); props.onClosed(); offerSignUpForChosenTime(time); }} />
    </>;
};
